import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import addHiddenInput from 'docs/src/modules/utils/addHiddenInput';
import SandboxDependencies from 'docs/src/modules/sandbox/Dependencies';
import flattenRelativeImports from 'docs/src/modules/sandbox/FlattenRelativeImports';
import * as CRA from 'docs/src/modules/sandbox/CreateReactApp';
function getFileExtension(codeVariant) {
  if (codeVariant === 'TS') {
    return 'tsx';
  }
  if (codeVariant === 'JS') {
    return 'jsx';
  }
  throw new Error("Unsupported codeVariant: ".concat(codeVariant));
}
function ensureExtension(file, extension) {
  return file.endsWith(".".concat(extension)) ? file : "".concat(file, ".").concat(extension);
}
var VITE_DEV_DEPENDENCIES = {
  '@vitejs/plugin-react': 'latest',
  vite: 'latest'
};
function _openStackBlitz(_ref) {
  var title = _ref.title,
    description = _ref.description,
    files = _ref.files,
    initialFile = _ref.initialFile;
  // ref: https://developer.stackblitz.com/docs/platform/post-api/
  var form = document.createElement('form');
  form.method = 'POST';
  form.target = '_blank';
  form.action = "https://stackblitz.com/run?file=".concat(initialFile);
  addHiddenInput(form, 'project[template]', 'node');
  addHiddenInput(form, 'project[title]', title);
  addHiddenInput(form, 'project[description]', "# ".concat(title, "\n").concat(description));
  Object.keys(files).forEach(function (key) {
    var value = files[key];
    addHiddenInput(form, "project[files][".concat(key, "]"), value);
  });
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}

/**
 * Create a Vite project config for StackBlitz
 */
function createViteFiles(demoData, dependencies, devDependencies, description) {
  var ext = getFileExtension(demoData.codeVariant);
  return _extends(_defineProperty(_defineProperty(_defineProperty({}, "vite.config.".concat(demoData.codeVariant === 'TS' ? 'ts' : 'js'), "\nimport { defineConfig } from 'vite';\nimport react from '@vitejs/plugin-react';\n\n// https://vitejs.dev/config/\nexport default defineConfig({\n  plugins: [react()],\n  define: { 'process.env': {} },\n});"), 'index.html', CRA.getHtml(_extends({}, demoData, {
    main: "/src/index.".concat(ext)
  }))), 'package.json', JSON.stringify({
    "private": true,
    description: description,
    type: 'module',
    scripts: {
      dev: 'vite',
      build: 'vite build',
      preview: 'vite preview'
    },
    dependencies: dependencies,
    devDependencies: devDependencies
  }, null, 2)), demoData.codeVariant === 'TS' && {
    'tsconfig.json': "{\n  \"compilerOptions\": {\n    \"target\": \"ES2020\",\n    \"useDefineForClassFields\": true,\n    \"lib\": [\"ES2020\", \"DOM\", \"DOM.Iterable\"],\n    \"module\": \"ESNext\",\n    \"skipLibCheck\": true,\n    \"moduleResolution\": \"bundler\",\n    \"allowImportingTsExtensions\": true,\n    \"resolveJsonModule\": true,\n    \"isolatedModules\": true,\n    \"noEmit\": true,\n    \"jsx\": \"react-jsx\",\n    \"strict\": true,\n    \"noUnusedLocals\": true,\n    \"noUnusedParameters\": true,\n    \"noFallthroughCasesInSwitch\": true\n  },\n  \"include\": [\"src\"],\n  \"references\": [{ \"path\": \"./tsconfig.node.json\" }]\n}",
    'tsconfig.node.json': "{\n  \"compilerOptions\": {\n    \"composite\": true,\n    \"skipLibCheck\": true,\n    \"module\": \"ESNext\",\n    \"moduleResolution\": \"bundler\",\n    \"allowSyntheticDefaultImports\": true\n  },\n  \"include\": [\"vite.config.ts\"]\n}"
  });
}

/**
 * Create a Material Template for StackBlitz using the SDK and Vite.
 */
function createJoyTemplate(templateData) {
  var _templateData$files;
  var ext = getFileExtension(templateData.codeVariant);
  var title = templateData.title,
    description = templateData.githubLocation;
  var raw = Object.entries((_templateData$files = templateData.files) != null ? _templateData$files : {}).reduce(function (prev, curr) {
    return "".concat(prev, "\n").concat(curr);
  }, '');
  var demoData = _extends({}, templateData, {
    raw: raw,
    language: 'en'
  });

  // Get dependencies
  var _SandboxDependencies = SandboxDependencies(demoData, {
      commitRef: process.env.PULL_REQUEST_ID ? process.env.COMMIT_REF : undefined,
      devDeps: VITE_DEV_DEPENDENCIES
    }),
    dependencies = _SandboxDependencies.dependencies,
    devDependencies = _SandboxDependencies.devDependencies;

  // Create base Vite files with dependencies
  var viteFiles = createViteFiles(demoData, dependencies, devDependencies, description);

  // Restructure template files to be under src/
  var templateSourceFiles = templateData.files ? Object.fromEntries(Object.entries(templateData.files).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return ["src/".concat(key), value];
  })) : {};

  // document.querySelector returns 'Element | null' but createRoot expects 'Element | DocumentFragment'.
  var type = templateData.codeVariant === 'TS' ? '!' : '';

  // Create a proper React 18 index file for Vite
  var indexContent = "import * as React from 'react';\nimport * as ReactDOM from 'react-dom/client';\nimport { StyledEngineProvider } from '@mui/joy/styles';\nimport App from './App';\n\nReactDOM.createRoot(document.querySelector(\"#root\")".concat(type, ").render(\n  <React.StrictMode>\n    <StyledEngineProvider injectFirst>\n      <App />\n    </StyledEngineProvider>\n  </React.StrictMode>\n);");

  // Combine all files
  var files = _extends({}, viteFiles, _defineProperty({}, "src/index.".concat(ext), indexContent), templateSourceFiles);
  return {
    title: title,
    files: files,
    dependencies: dependencies,
    devDependencies: devDependencies,
    replaceContent: function replaceContent(updater) {
      Object.keys(files).forEach(function (filePath) {
        files[filePath] = updater(files[filePath], filePath);
      });
      return this;
    },
    openStackBlitz: function openStackBlitz() {
      var initialFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'src/App';
      _openStackBlitz({
        title: title,
        description: description,
        files: files,
        initialFile: ensureExtension(initialFile, ext)
      });
    }
  };
}
/**
 * Create a Material Template for StackBlitz using the SDK and Vite.
 */
function createMaterialTemplate(templateData) {
  var _templateData$files2;
  var ext = getFileExtension(templateData.codeVariant);
  var title = templateData.title,
    description = templateData.githubLocation;
  var raw = Object.entries((_templateData$files2 = templateData.files) != null ? _templateData$files2 : {}).reduce(function (prev, curr) {
    return "".concat(prev, "\n").concat(curr);
  }, '');
  var demoData = _extends({}, templateData, {
    raw: raw,
    language: 'en'
  });

  // Get dependencies
  var _SandboxDependencies2 = SandboxDependencies(demoData, {
      commitRef: process.env.PULL_REQUEST_ID ? process.env.COMMIT_REF : undefined,
      devDeps: VITE_DEV_DEPENDENCIES
    }),
    dependencies = _SandboxDependencies2.dependencies,
    devDependencies = _SandboxDependencies2.devDependencies;

  // Create base Vite files with dependencies
  var viteFiles = createViteFiles(demoData, dependencies, devDependencies, description);

  // Restructure template files to be under src/
  var templateSourceFiles = templateData.files ? Object.fromEntries(Object.entries(templateData.files).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    return ["src/".concat(key), value];
  })) : {};

  // Create a proper React 18 index file for Vite
  var indexContent = "\nimport * as React from 'react';\nimport * as ReactDOM from 'react-dom/client';\nimport { StyledEngineProvider } from '@mui/material/styles';\nimport App from './App';\n\nReactDOM.createRoot(document.getElementById('root')".concat(templateData.codeVariant === 'TS' ? '!' : '', ").render(\n  <React.StrictMode>\n    <StyledEngineProvider injectFirst>\n      <App />\n    </StyledEngineProvider>\n  </React.StrictMode>\n);");

  // Combine all files
  var files = _extends({}, viteFiles, _defineProperty({}, "src/index.".concat(ext), indexContent), templateSourceFiles);
  return {
    title: title,
    files: files,
    dependencies: dependencies,
    devDependencies: devDependencies,
    replaceContent: function replaceContent(updater) {
      Object.keys(files).forEach(function (filePath) {
        files[filePath] = updater(files[filePath], filePath);
      });
      return this;
    },
    openStackBlitz: function openStackBlitz() {
      var initialFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'src/App';
      _openStackBlitz({
        title: title,
        description: description,
        files: files,
        initialFile: ensureExtension(initialFile, ext)
      });
    }
  };
}

/**
 * Create a React App for StackBlitz using the SDK and Vite.
 * This maintains similar structure to the original createReactApp but uses Vite.
 */
function createReactApp(demoData) {
  var ext = getFileExtension(demoData.codeVariant);
  var title = demoData.title,
    description = demoData.githubLocation;

  // Get dependencies
  var _SandboxDependencies3 = SandboxDependencies(demoData, {
      commitRef: process.env.PULL_REQUEST_ID ? process.env.COMMIT_REF : undefined,
      devDeps: VITE_DEV_DEPENDENCIES
    }),
    dependencies = _SandboxDependencies3.dependencies,
    devDependencies = _SandboxDependencies3.devDependencies;
  var viteFiles = createViteFiles(demoData, dependencies, devDependencies, description);
  var demoFiles = _defineProperty({}, "src/Demo.".concat(ext), flattenRelativeImports(demoData.raw));

  // Add relative modules if any
  var relativeModuleFiles = demoData.relativeModules ? demoData.relativeModules.reduce(function (acc, curr) {
    return _extends({}, acc, _defineProperty({}, "src/".concat(curr.module.replace(/^.*[\\/]/g, '')), flattenRelativeImports(curr.raw)));
  }, {}) : {};

  // Combine all files
  var files = _extends({}, viteFiles, _defineProperty({}, "src/index.".concat(ext), CRA.getRootIndex(demoData)), demoFiles, relativeModuleFiles);
  return {
    title: title,
    description: description,
    files: files,
    dependencies: dependencies,
    devDependencies: devDependencies,
    openSandbox: function openSandbox() {
      var initialFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'src/Demo';
      _openStackBlitz({
        title: title,
        description: description,
        files: files,
        initialFile: ensureExtension(initialFile, ext)
      });
    }
  };
}
export default {
  createJoyTemplate: createJoyTemplate,
  createReactApp: createReactApp,
  createMaterialTemplate: createMaterialTemplate
};